<template>
  <div
    class="btn"
    :style="{
      border: Data.border,
      background: Data.background,
      color: Data.color,
    }"
  >
    <i v-if="Data.iconfont" :class="Data.iconfont"></i>
    <div class="name">
      {{ Data.name }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["Data"],
};
</script>

<style lang="scss" scoped>
.btn {
  z-index: 99;
  padding: 4px 8px;
  border-radius: 2px;
  margin-left: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 32px;
  white-space: nowrap;
      width: fit-content;
  transition: 0.2s;
  &:hover {
    opacity: 0.7;
    transition: 0.2s;
  }
  i {
    margin-right: 6px;
  }
  .name {
    font-size: 12px;
  }
}
</style>